import Footer from "../../components/common/footer";
import HeaderTwo from "../../components/common/headerTwo";
import { Helmet } from "react-helmet";
import Offer2RownanieTerenu from "../../components/offer/2rownanieTerenu";

function K1MulczerLesny() {
  return (
    <>
      <Helmet>
        <title>Równanie terenu pod budowę i trawnik minikoparką | Gdańsk, Wejherowo, Kartuzy</title>
        <meta name="title" content="Równanie terenu pod budowę i trawnik minikoparką | Gdańsk, Wejherowo, Kartuzy" />
        <meta
          name="description"
          content="Maszynowe równanie i wyrównywanie terenu działek budowlanych i ogrodowych ciężkim sprzętem. Usługi na terenie Gdańska, Gdyni, Wejherowa, Kartuz i całych Kaszub."
          key="desc"
        />
        <meta
          property="og:title"
          content="Równanie terenu pod budowę i trawnik minikoparką | Gdańsk, Wejherowo, Kartuzy"
        />
        <meta
          property="og:description"
          content="Maszynowe równanie i wyrównywanie terenu działek budowlanych i ogrodowych ciężkim sprzętem. Usługi na terenie Gdańska, Gdyni, Wejherowa, Kartuz i całych Kaszub."
        />
        <meta
          property="og:image"
          content="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/logo-white-10.55.05.png"
        />
      </Helmet>
      <HeaderTwo />
      <main className="relative z-40">
        <Offer2RownanieTerenu />
      </main>
      <Footer />
    </>
  );
}
export default K1MulczerLesny;
